export default __webpack_public_path__ + "static/media/depannages.e379baaa.svg";